const button = {
  variants: {
    primary: {
      position: "relative",
      textTransform: "uppercase",
      letterSpacing: "widest",
      color: "text.d100",
      bg: "primary.200",
      boxShadow:
        "0 0.1rem 0.1rem rgba(0,0,0,0.25), 0 0.2rem 0.2rem rgba(0,0,0,0.2), 0 0.4rem 0.4rem rgba(0,0,0,0.15), 0 0.8rem 0.8rem rgba(0,0,0,0.1), 0 1.6rem 1.6rem rgba(0,0,0,0.05)",

      _hover: { bg: "white" },
      _active: { bg: "white" },
    },
    ghost: {
      textTransform: "uppercase",
      letterSpacing: "widest",
    },
  },
}

export default button
